export default () => {
	const init = () => {
		// Document resources
		for (const el of document.querySelectorAll("[data-resource-document")) {
			const linkEl = el.querySelector("a");
			if (linkEl !== null) {
				linkEl.addEventListener("click", (e) => {
					ga("send", "event", "Resource download", "Download", e.target.href);
				});
			}
		}

		// Link resources
		for (const el of document.querySelectorAll("[data-resource-link")) {
			const linkEl = el.querySelector("a");
			if (linkEl !== null) {
				linkEl.addEventListener("click", (e) => {
					ga("send", "event", "Resource link", "Click", e.target.href);
				});
			}
		}

		// Newsletter signup links
		for (const el of document.querySelectorAll(
			"[data-newsletter-signup-link]",
		)) {
			el.addEventListener("click", (e) => {
				ga("send", "event", "Newsletter signup", "Click", e.target.href);
			});
		}

		// Header log in button
		const loginBtn = document.querySelector("[data-header-login-btn]");
		if (loginBtn !== null) {
			loginBtn.addEventListener("click", (e) => {
				ga(
					"send",
					"event",
					"Login Button Header Click",
					"Click",
					e.target.href,
				);
			});
		}

		// Homepage hero tiles
		for (const el of document.querySelectorAll(
			"[data-homepage-hero-tiles] a",
		)) {
			el.addEventListener("click", (e) => {
				ga("send", "event", "Homepage Hero Tile Click", "Click", el.innerHTML);
			});
		}

		// Homepage helpful links
		for (const el of document.querySelectorAll(
			"[data-homepage-helpful-links] a",
		)) {
			el.addEventListener("click", (e) => {
				ga(
					"send",
					"event",
					"Homepage Quicklink Tile Click",
					"Click",
					el.innerHTML,
				);
			});
		}

		// Meganav section landing page links
		for (const el of document.querySelectorAll(
			"[data-meganav-section-landing-link]",
		)) {
			el.addEventListener("click", (e) => {
				ga("send", "event", "Meganav Home Link", "Click", el.innerHTML);
			});
		}

		// Social share links
		for (const el of document.querySelectorAll("[data-social-share-link]")) {
			el.addEventListener("click", (e) => {
				ga(
					"send",
					"event",
					"Social Share Link",
					"Click",
					el.getAttribute("data-social-share-link"),
				);
			});
		}
	};

	// Keep checking that GA is available and run init() function when ready
	const checkGa = () => {
		if (typeof ga === "function") {
			init();
		} else {
			setTimeout(checkGa, 500);
		}
	};
	checkGa();
};
